// src/services/messageTemplateService.ts
import { db } from '../config/firebase';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';

export interface MessageTemplate {
  id: string;
  name: string;
  content: string;
  createdAt?: Date;
  updatedAt?: Date;
}

const templatesCollectionRef = collection(db, 'messageTemplates');

// Função para obter todos os templates
export const getTemplates = async (): Promise<MessageTemplate[]> => {
  try {
    const querySnapshot = await getDocs(templatesCollectionRef);
    const templates = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as MessageTemplate));
    return templates.sort((a, b) => a.name.localeCompare(b.name)); // Ordena por nome
  } catch (error) {
    console.error("Erro ao buscar templates do Firestore:", error);
    throw error;
  }
};

// Função para obter um template específico por ID
export const getTemplateById = async (templateId: string): Promise<MessageTemplate | null> => {
  try {
    const docRef = doc(db, 'messageTemplates', templateId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as MessageTemplate;
    }
    return null;
  } catch (error) {
    console.error("Erro ao buscar template por ID:", error);
    throw error;
  }
};

// Função para criar um novo template
export const createTemplate = async (templateData: Omit<MessageTemplate, 'id'>): Promise<string> => {
  try {
    const docRef = await addDoc(templatesCollectionRef, {
      ...templateData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return docRef.id;
  } catch (error) {
    console.error("Erro ao criar template no Firestore:", error);
    throw error;
  }
};

// Função para atualizar um template existente
export const updateTemplate = async (templateId: string, updates: Partial<MessageTemplate>): Promise<void> => {
  try {
    const docRef = doc(db, 'messageTemplates', templateId);
    await updateDoc(docRef, {
      ...updates,
      updatedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Erro ao atualizar template no Firestore:", error);
    throw error;
  }
};

// Função para deletar um template
export const deleteTemplate = async (templateId: string): Promise<void> => {
  try {
    const docRef = doc(db, 'messageTemplates', templateId);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Erro ao deletar template do Firestore:", error);
    throw error;
  }
};